var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlistFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "450.000000pt",
    viewBox: "0 0 512.000000 450.000000",
    preserveAspectRatio: "xMidYMid meet",
    className: "added",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,450.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1218 4365 c-2 -3 -27 -7 -54 -9 -27 -3 -49 -5 -49 -6 0 -1 -9 -4 -20 -6 -11 -3 -24 -6 -30 -8 -32 -9 -101 -29 -110 -31 -10 -2 -38 -12 -110 -41 -63 -26 -114 -53 -200 -109 -306 -197 -523 -539 -582 -915 -10 -61 -9 -324 1 -385 4 -27 9 -59 11 -70 23 -138 136 -391 235 -525 42 -57 282 -306 724 -748 1021 -1024 1384 -1385 1415 -1405 43 -27 122 -33 173 -13 35 13 238 211 1089 1063 962 964 1052 1056 1113 1150 100 151 189 371 208 515 2 13 6 28 10 33 9 15 7 378 -2 390 -5 6 -8 12 -8 15 1 3 -2 26 -6 52 -17 116 -119 360 -198 476 -118 175 -302 343 -463 424 -33 17 -62 33 -65 37 -3 3 -13 7 -23 9 -10 2 -39 12 -65 24 -26 11 -72 27 -102 34 -30 8 -63 17 -72 19 -91 25 -144 30 -323 30 -149 -1 -207 -4 -265 -18 -8 -2 -33 -7 -55 -12 -158 -31 -378 -136 -510 -243 -16 -13 -84 -76 -150 -140 -66 -65 -135 -130 -152 -146 l-33 -29 -142 139 c-79 77 -177 166 -219 197 -82 61 -217 138 -277 158 -20 6 -41 15 -47 19 -10 7 -70 24 -70 19 0 -1 -11 3 -24 10 -13 7 -38 15 -55 18 -43 7 -61 11 -61 14 0 1 -11 2 -25 3 -14 1 -29 4 -35 8 -12 7 -370 10 -377 3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistFilled);
export default __webpack_public_path__ + "static/media/wishlist-filled.886f5030.svg";
export { ForwardRef as ReactComponent };